import {Base} from './base.model';
import { DatePipe } from '@angular/common';

export class Premium extends Base{
	id: string;
	private _dialPattern: string;
	dialPatternType: "Prime" | "Prime-1" | "Prime-2" | "Prime-3" | "Prime-4";
	prime: string;
	primeMinus1: string;
	primeMinus2: string;
	primeMinus3: string;
	primeMinus4: string;
	termCountry: string;
	ccNdc: string;
	iso2: string;
	code: string;
	tos: string;
	tosdesc: string;
	ndc: string;
	locality: string;
	provider: string;
	lemin:number;
	lemax:number;
	supplement: string;
	// lastUpdate: string;
	firstSeen: string;
	lastSeen: string;

	static toString(p:Premium,  delimiter: string): string {
		let result = [];
		result.push(p.primeMinus1);
		result.push(p.primeMinus2);
		result.push(p.primeMinus3);
		result.push(p.primeMinus4);
		result.push(p.termCountry);
		result.push(p.code);
		result.push(p.ndc);
		result.push(p.iso2);
		result.push(p.termCountry);
		result.push(p.tos);
		result.push(p.tosdesc);
		result.push(p.provider);
		result.push(p.supplement);
		result.push(p.lemin);
		result.push(p.lemax);
		// if (p.lastUpdate) {
		// 	result.push(p.lastUpdate.replace('-', ''));
		// } else {
		// 	result.push('');
		// }
		result.push(p.firstSeen? p.firstSeen: '');
		result.push(p.lastSeen ? p.lastSeen: '');
		return result.join(delimiter);
	}
}
